import type {JSX} from 'react'
import {LoadingSpinner} from '@/_new-code/products/flexible-web-toolkit/components/loading-spinner'

interface LoadingStateProps {
	theme: string
	isLoading: boolean
}

export const LoadingState = ({
	theme,
	isLoading,
}: LoadingStateProps): JSX.Element | null => {
	if (!isLoading) return null

	return (
		<div className="absolute bottom-0 left-0 right-0 top-0 z-20 flex items-center justify-center bg-white/70">
			<LoadingSpinner theme={theme} />
		</div>
	)
}
